import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://gjamvfwvqlizginqdfhd.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdqYW12Znd2cWxpemdpbnFkZmhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc5NjAyNjAsImV4cCI6MjA3MzUzNjI2MH0.fbqHrjfRC7JK5BDMNA52kdeEhppKUMwQMRHW2i0PG0U'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})
